/**
 * WP10d / #46643 — TanStack route for searchable not-found recovery.
 *
 * `/not-found` is a real content page inside the verification shell. Unknown
 * old object ids hop here via `resolveUnknownOldIdRedirect` (query preserved,
 * `q` set to the unknown id). Canonical `/` is not a redirect in this cluster.
 */

import { createRoute } from "@tanstack/react-router";
import { useNavigate, useSearch } from "@excellent/ui/router";
import { rootRoute } from "./__root";
import { VerificationShell } from "../verification/shell";
import { NotFoundRecoveryPage } from "../verification/pages/not-found-recovery";

function VerificationNotFoundRecovery() {
  const navigate = useNavigate();
  const params = useSearch();
  const query = params.get("q") ?? "";
  const unknownId = query.trim();

  return (
    <div data-route="verification-not-found">
      <VerificationShell>
        <NotFoundRecoveryPage
          onNavigate={(to) => navigate.push(to)}
          query={query}
          unknownId={unknownId}
          onSearch={(q) => {
            const dest = q ? `/not-found?q=${encodeURIComponent(q)}` : "/not-found";
            navigate.push(dest);
          }}
        />
      </VerificationShell>
    </div>
  );
}

export const verificationNotFoundRecoveryRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/not-found",
  component: VerificationNotFoundRecovery,
});
